.wrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(128,128,128,0.8);
  opacity: 1;
  visibility: hidden;
  transform: scale(1.1);
  transition: visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s;
  z-index: 1;
}

.visible {
  visibility: visible;
  transform: scale(1);
  transition: visibility 0s linear 0s, opacity 0.25s 0s, transform 0.25s;
}

.modal {
  font-family: sans-serif;
  font-size: 14px;
  padding: 8px 8px 4px 8px;
  background-color: #FFFFFF;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 300px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  gap: 16px;
  margin-bottom: 16px;
}

.title {
  font-size: 18px;
}

.header-controls {
  display: flex;
  align-items: center;
  align-content: center;
  gap: 4px;
}

.close-control {
  height: 32px;
  width: 32px;
  padding: 0;
  cursor: pointer;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  gap: 16px;
  margin-top: 16px;
}

.footer-left, .footer-center, .footer-right {
  display: flex;
  align-items: center;
  align-content: center;
  gap: 4px;
}


